<template>
  <div class="submit">
    <page-header />
    <audit-temp :audit_status="audit_status" :audit_remark="audit_remark" />
    <section class="main">
      <div class="letter">
        <h4>作品承诺书</h4>
        <span v-html="reg_commit_letter"></span>
        <h5>
          点击同意：
          <el-switch :value="is_agree === 2" active-color="#13ce66" inactive-color="#ccc" @change="onChangeAgree" :disabled="inputDisabled">
          </el-switch>
        </h5>
      </div>
      <div class="prompt" v-if="!inputDisabled">提示：点击提交后所有信息将不能修改，并且不能撤回！</div>
      <div class="btn">
        <el-button type="primary" icon="el-icon-back" @click="onPrevPage">返回上一项</el-button>
        <el-button v-if="!inputDisabled" type="success" icon="el-icon-circle-check" @click="onSubmit">确认无误，提交报名</el-button>
        <el-button v-else type="success" icon="el-icon-circle-check" @click="$router.push('/result')">查看结果</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import AuditTemp from '@/components/AuditTemp'
import { fetchFileConfig, submit } from '@/service/api'

export default {
  name: 'PageSubmit',
  components: {
    PageHeader,
    AuditTemp
  },
  data () {
    return {
      audit_status: 3,
      is_agree: 1,
      audit_remark: '',
      reg_commit_letter: ''
    }
  },
  computed: {
    inputDisabled () {
      return this.audit_status === 2 || this.audit_status === 4 || this.audit_status === 5
    }
  },
  methods: {
    onPrevPage () {
      this.$router.push('/works')
    },
    async getFileConfig () {
      try {
        const data = await fetchFileConfig()
        // is_agree: 1=不同意 2=同意
        this.is_agree = data.reg_team_basic.is_agree
        this.audit_status = data.reg_team_basic.audit_status
        this.audit_remark = data.reg_team_basic.audit_remark
        this.reg_commit_letter = data.reg_commit_letter
      } catch (error) {
        console.log('getFileConfig error', error)
      }
    },
    onChangeAgree (tag) {
      this.is_agree = tag ? 2 : 1
    },
    onSubmit () {
      if (this.is_agree !== 2) {
        this.$alert(`请阅读作品承诺书确认无误后点击同意`, '提示', {
          confirmButtonText: '确定'
        })
        return
      }

      this.$confirm('点击提交后所有信息将不能修改，并且不能撤回！ ', '提示', {
        confirmButtonText: '继续提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.9)'
        })

        try {
          await submit()
          loading.close()
          this.$router.push('/result')
        } catch (error) {
          loading.close()
          this.$alert(error, '提示', {
            confirmButtonText: '确定'
          })
          console.log('onSubmit error', error)
        }
      }).catch(() => {
        console.log('取消')
      })
    }
  },
  async mounted () {
    document.body.style.height = '100%'
    await this.getFileConfig()
  },
  unmounted () {
    document.body.style.height = '100%'
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
